import { GatsbyImage } from 'gatsby-plugin-image';
import * as React from 'react';

import type { ISanityHero } from '../../fragments/sanity-hero-parts';
import { classNames } from '../../utils/classnames';
import { ButtonLink } from '../button-link';

interface HeroProps {
  hero: ISanityHero;
  title: String;
}

function Hero({ hero, title }: HeroProps): JSX.Element {
  const maxHeight = hero.isSmall ? 'max-h-[24rem]' : 'max-h-[36rem]';
  const darken = hero.isSmall ? 'opacity-60' : '';
  console.log('Title = ', title);
  return !hero.youtubeVideoId ? (
    <>
      <div
        className={classNames(maxHeight, 'relative overflow-hidden bg-black')}
      >
        <div className="md:aspect-w-16 md:aspect-h-9">
          {hero.backgroundImage?.asset ? (
            <div
              className={classNames(
                maxHeight,
                'absolute inset-0 flex md:inset-auto md:pointer-events-none'
              )}
            >
              <GatsbyImage
                image={hero.backgroundImage.asset.gatsbyImageData}
                alt={hero.backgroundImage.alt || ''}
                imgClassName={classNames(darken, 'flex-1')}
              />
            </div>
          ) : null}
          <div
            className={classNames(
              maxHeight,
              'relative flex flex-col items-center justify-center py-12 text-center bg-opacity-50 bg-dark px-4 sm:px-6 lg:px-8'
            )}
          >
            {hero.heading.length > 1 ? (
              <div>
                <h1 className="max-w-4xl mx-auto my-8 font-serif text-5xl text-highlight-ochre md:text-7xl xl:text-8xl">
                  {hero.heading[0].text.split(' ')[0]} <br />
                  {hero.heading[0].text.split(' ').slice(1).join(' ')}
                </h1>
                <p className="max-w-xs mx-auto my-6 text-xs font-normal tracking-widest md:text-lg md:max-w-xl">
                  {hero.heading[1].text}
                </p>
              </div>
            ) : (
              <h1 className="max-w-4xl font-serif text-3xl font-normal uppercase md:text-6xl">
                {hero.heading[0].text}
              </h1>
            )}

            <p className="mt-2">
              {hero.ctas
                ? hero.ctas.map((cta) => (
                    <ButtonLink
                      key={cta.id}
                      link={cta}
                      colourScheme={
                        cta.styles?.style === 'is-outline' ? 'dark' : 'light'
                      }
                    />
                  ))
                : null}
            </p>
          </div>
        </div>
      </div>
      {/* {title === 'Book Now' && (
        <div className="w-full px-4 py-12 mx-auto leading-6 text-center lg:leading-9 text-md lg:text-lg bg-primary sm:px-6 lg:px-24">
          NOTE. In compliance with NSW Health regulations, from October 11,
          persons 16 and over will need to be fully vaccinated or have a valid
          medical exemption to enter our facility; and our staff will be
          responsible for checking vaccination status upon entry, and only
          accepting valid forms of evidence of vaccination or medical exemption.
          People under 16 years who are not fully vaccinated must be with a
          fully vaccinated member of their household. So please be aware of this
          when booking, and only book if you will be able to comply with this
          requirement when you arrive for your game. THANK YOU.
        </div>
      )} */}
    </>
  ) : (
    <div className="relative aspect-w-16 aspect-h-9">
      <video
        className="absolute inset-0"
        playsInline
        autoPlay
        muted
        loop
        poster="https://res.cloudinary.com/dcjxj2iad/image/upload/v1635313991/poster_kifjvz.jpg"
      >
        <source
          src="https://res.cloudinary.com/dcjxj2iad/video/upload/v1635312379/yt5s.com-Welcome_to_Facade_Escape_Room_ctmcit.mp4"
          type="video/mp4"
        />
      </video>
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      <h2 className="flex items-center justify-center font-serif text-4xl lg:text-7xl text-highlight-ochre">
        Facade Escape Room
      </h2>
    </div>
  );
}

export { Hero };
